
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-voice-assistant-development-services",
      function () {
        return require("private-next-pages/ai-voice-assistant-development-services.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-voice-assistant-development-services"])
      });
    }
  